<template>
  <div class="nmz_trailer_wrap">
    <Swiper v-if="data_list && data_list.length > 0" :info="info" :data_list="data_list" />
  </div>
</template>
<script>
import Swiper from './NzmTrailer/Swiper';
import { getJSON, postJSON } from '../../api/myaxios';
import { urlToWebp } from '../../tools/tpl';
import { HIDE_COMP } from '../../constant/eventbus';
import { formatTrailerTime } from '../../tools/time-format';
import { onUseInfoLoad } from '../../tools/onUseInfoLoad';

export default {
  name: 'NzmTrailer',
  components: {
    Swiper
  },
  props: {
    info: {
      type: Object
    }
  },
  data: function() {
    return {
      data_list: []
    };
  },
  methods: {
    get_detail() {
      getJSON(
        '//vipact3.api.mgtv.com/api/v1/act/img/get',
        {
          act_name: this.info.act_name,
          invoker: window.gact.invoker,
          f_release: window.gact.f_release
        },
        10000,
        false,
        true
      ).then(res => {
        if (!res) {
          return;
        }
        if (res.ret === 0) {
          const list = res.data.list;
          if (list.length === 0) {
            console.log('没有内容，隐藏模块', this.info.act_name);
            window.$bus.$emit(HIDE_COMP, this.info.act_name);
            return;
          }
          list.forEach(item => {
            !item.img_preview && (item.img_preview = item.img);
            item.img = urlToWebp(item.img);
            item.img_preview = urlToWebp(item.img_preview);
            item._show_time = new Date(item.show_time.replace(/-/g, '/')).getTime(); // 添加到日历的时间
            item.show_time = formatTrailerTime(item.show_time);
            item.trailer = false;
          });
          this.data_list = list.slice(0, this.max_num);
          // console.log(this.data_list);
          onUseInfoLoad(() => {
            this.queryTrailerState(list.map(item => item.id));
          });
        }
      });
    },
    queryTrailerState(ids) {
      // console.log('queryTrailerState ', ids, window.$bus.user.ticket);
      //https://wiki.imgo.tv/pages/viewpage.action?pageId=5088912
      postJSON('//vipact3.api.mgtv.com/api/v1/act/appointment/stat/query', null, {
        act_name: this.info.act_name,
        phase_list: ids,
        ticket: window.$bus.user.ticket
      }).then(res => {
        // console.log('queryTrailerState resp:', res);
        if (res && res.ret === 0 && res.data) {
          this.data_list.forEach(item => {
            item.trailer = !!Object.keys(res.data[item.id]).length;
          });
          // console.log('data_list: ', this.data_list);
        }
      });
    }
  },
  computed: {
    max_num: function() {
      return this.info.config.max_num || 999999;
    }
  },
  mounted() {
    this.get_detail();
  }
};
</script>

<style lang="stylus">
.nmz_trailer_wrap
  position relative
  overflow hidden
</style>
